import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";


export const getEnrolledCourses = async (studentId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "core_enrol_get_users_courses",
          userid: studentId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getCourseCategories = async () => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "core_course_get_categories",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getCourseDetails = async (courseId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "core_course_get_courses_by_field",
          field: "id",
          value: courseId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getCourseContents = async (courseId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "core_course_get_contents",
          courseid: courseId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getModPageContent = async (courseId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_page_get_pages_by_courses",
          "courseids[0]": courseId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};


export const enrollCourse = async (courseId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_selfenrol_ws_self_enrol",
          courseid: courseId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
}

export const unenrollCourse = async (courseId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_self_unenrol_unenrol_self",
          courseid: courseId,
        },
      }
    );
    return response.data
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
}

export const getTypeEnrol = async () => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_check_enrolment_type_check",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
}
